var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exchange",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60547 12.7617C7.60547 13.2021 7.29395 13.5137 6.83203 13.5137C6.64941 13.5137 6.42383 13.4277 6.27344 13.2773L0.257812 7.33691C0.0859375 7.16504 0 6.97168 0 6.75684C0 6.54199 0.0859375 6.34863 0.257812 6.17676L6.27344 0.236328C6.42383 0.0859375 6.64941 0 6.83203 0C7.29395 0 7.60547 0.311523 7.60547 0.762695C7.60547 0.977539 7.53027 1.14941 7.39062 1.28906L4.29688 4.3291L2.30957 6.08008L4.66211 5.9834H18.3154C18.7559 5.9834 19.0889 6.30566 19.0889 6.75684C19.0889 7.20801 18.7559 7.53027 18.3154 7.53027H4.66211L2.30957 7.43359L4.29688 9.18457L7.39062 12.2246C7.53027 12.3643 7.60547 12.5361 7.60547 12.7617ZM12.8047 23.1494C12.6543 23.2998 12.4395 23.3965 12.2461 23.3965C11.7842 23.3965 11.4834 23.0742 11.4834 22.6338C11.4834 22.4082 11.5586 22.2363 11.6875 22.0967L14.792 19.0566L16.7686 17.3057L14.4268 17.4023H0.773438C0.322266 17.4023 0 17.0801 0 16.6289C0 16.1885 0.322266 15.8662 0.773438 15.8662H14.4268L16.7686 15.9521L14.792 14.2012L11.6875 11.1611C11.5586 11.0322 11.4834 10.8496 11.4834 10.6348C11.4834 10.1836 11.7842 9.87207 12.2461 9.87207C12.4395 9.87207 12.6543 9.95801 12.8047 10.1084L18.8311 16.0596C19.0029 16.2207 19.0889 16.4141 19.0889 16.6289C19.0889 16.8438 19.0029 17.0479 18.8311 17.209L12.8047 23.1494Z",
    fill: "#777e8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.2c96a3a207089281717c0851d37ed48c.svg";
export { ForwardRef as ReactComponent };